module.exports = __webpack_public_path__ + "static/img/2.4ad3503.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/sp/2.png
// module id = cmSt
// module chunks = 0